"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _swr = _interopRequireDefault(require("swr"));
var useCategories = function useCategories(language, fetchedCategories) {
  return (0, _swr["default"])([language, "useCategories"], _fetcher["default"], {
    initialData: fetchedCategories
  });
};
var _default = useCategories;
exports["default"] = _default;